var module = angular.module('octopusApp.shared');

module.directive('csvSplitFormatter', function() {
    return {
        restrict: 'A',
        require: 'ngModel',
        link: function(scope, element, attr, ngModel) {
            var fromCsv = function(text) {
                if(text && text !== ''){
                    return text.split(',');
                }
                return [];
            };
            var toCsv = function(data) {
                return (data || []).join(',');
            };
            ngModel.$parsers.push(toCsv);
            ngModel.$formatters.push(fromCsv);
        }
    };
});


//////////////////
// WEBPACK FOOTER
// ./app/areas/shared/directives/csv-split-formatter.js.js
// module id = 2335514065723040
// module chunks = 1